import { Component, EventEmitter, OnDestroy, Output, inject } from '@angular/core';
import {Subscription} from 'rxjs';
import {ApplicationService} from '../../service/application.service';
import {ActiveOrderService} from '../../service/active.order.service';
import {ActiveOrder} from '../../classes/active.order';
import {CustomDatePipe} from '../../pipes/custom.date.pipe';
import {RenderDayOfWeekAbbreviationComponent} from './render.day.of.week.abbr';
import {FormsModule} from '@angular/forms';
import {NgClass} from '@angular/common';

/**
 * @author evandongen
 */
@Component({
	selector: 'order-tabs',
	styleUrls: ['./ordertabs.component.scss'],
	templateUrl: 'ordertabs.component.html',
	standalone: true,
	imports: [NgClass, FormsModule, RenderDayOfWeekAbbreviationComponent, CustomDatePipe]
})
export class OrderTabsComponent implements OnDestroy {
	applicationService = inject(ApplicationService);
	activeOrderService = inject(ActiveOrderService);

	allProductsValue = 'allProducts';
	newProductValue = 'new';
	@Output() changeOrderEvent = new EventEmitter();
	@Output() clickedAllProductsEvent = new EventEmitter();
	private selectedOrderChangedSubscription: Subscription;

	constructor() {
		const activeOrderService = this.activeOrderService;

		this.setSelectStateForActiveOrder(activeOrderService.selectedOrder);

		this.selectedOrderChangedSubscription =
			activeOrderService.selectedOrderChangedSubject.subscribe((newActiveOrder) => {
				this.setSelectStateForActiveOrder(newActiveOrder);
			});
	}

	private _selectedOrder: any = this.allProductsValue;

	get selectedOrder() {
		return this._selectedOrder;
	}

	get activeOrders(): Array<ActiveOrder> {
		return this.activeOrderService.activeOrders
			? this.activeOrderService.activeOrders.filter(activeOrder => activeOrder.addProductsAllowed !== false)
			: [];
	}

	get firstActiveOrder(): ActiveOrder {
		return this.activeOrders && this.activeOrders.length > 0
			? this.activeOrders[0]
			: null;
	}

	ngOnDestroy() {
		this.selectedOrderChangedSubscription.unsubscribe();
	}

	showOrderSwitcher(): boolean {
		return this.selectedOrder !== this.allProductsValue;
	}

	unSelectOrder(): void {
		this.activeOrderService.setSelectedOrder(null);
		this.changeOrderEvent.emit();
		this.clickedAllProductsEvent.emit();
	}

	/**
	 * Opens the starts new order dialog,
	 * and after the submit closes this opened popup.
	 * The generic logic in StartOrderComponent handles the activation of the 'active order'.
	 */
	startNewOrder(): void {
		this.applicationService.openPopup(this.applicationService.closePopup);
	}

	/**
	 * Submit handler - check if 'add new' is selected or if another order was selected
	 *
	 * @param activeOrder
	 */
	changeOrder(activeOrder: ActiveOrder | string) {
		if (activeOrder === this.newProductValue) {
			this.setSelectStateForActiveOrder(this.newProductValue);
			this.applicationService.openPopupForNew(this.applicationService.closePopup);

			return;
		}

		if (activeOrder === this.allProductsValue) {
			this.unSelectOrder();
			return;
		}

		this.activeOrderService.setSelectedOrder(<ActiveOrder>activeOrder);
		this.changeOrderEvent.emit();
	}

	trackByOrder(index, order) {
		return order.shipmentDate;
	}

	private setSelectStateForActiveOrder(newActiveOrder) {
		this._selectedOrder =
			newActiveOrder != null ? newActiveOrder : this.allProductsValue;
	}
}
